var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full",staticStyle:{"background-color":"#f8f8f8"}},[_c('div',{staticClass:"text-xl font-medium my-4"},[_vm._v("Last Volunteer Locations")]),_c('Map',{staticClass:"inline-block",attrs:{"center":_vm.location,"zoom":_vm.zoom,"features":_vm.features,"submissions":_vm.knownLocations,"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }